import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { TrendingSearchTranslationEntity } from './TrendingSearchTranslationEntity'

export class CreateUpdateTrendingSearchEntity {
  channel?: ChannelMiniEntity | null
  translations?: Array<TrendingSearchTranslationEntity> | null
}
